import { Bookmark } from "lucide-react";

interface CheckpointBlockProps {
  label?: string;
  onRestore?: () => void;
}

export function CheckpointBlock({ label, onRestore }: CheckpointBlockProps) {
  return (
    <div className="my-3 flex items-center gap-3">
      <div className="h-px flex-1 bg-border" />
      <button
        type="button"
        className="flex items-center gap-1.5 rounded-full border border-border bg-muted/50 px-3 py-1 text-xs text-muted-foreground hover:bg-accent hover:text-foreground transition-colors"
        onClick={onRestore}
        disabled={!onRestore}
        title="Restore to this point"
      >
        <Bookmark className="h-3 w-3" />
        {label ?? "Checkpoint"}
      </button>
      <div className="h-px flex-1 bg-border" />
    </div>
  );
}
